import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

/**
 * Toggle-Switch
 * Usage: <ToggleSwitchV2 v-model:initState="toggleState" activeText="Yes" inactiveText="No" :disabled="false" />
 *
 * @export
 * @class ToggleSwitch
 * @extends {Vue}
 */
@Options({
  props: {
    activeText: String,
    inactiveText: String,
    label: String,
    initState: Boolean,
    disabled: Boolean,
  },
  emits: ['update:initState'],
  components: {}
})
export default class ToggleSwitchV2 extends Vue {
  activeText!: string;
  inactiveText!: string;
  label!: string;
  initState!: boolean;
  disabled!: boolean;

  private id = this.$guid();
  private newState = false;

  @Watch('initState')
  private onValueChange(): void {
    this.newState = this.initState;
  }

  private changeState() {
    this.$emit('update:initState', this.newState);
  }

  mounted(): void {
    this.newState = this.initState;
  }

  public $guid() {
    const S4 = () => {
      // tslint:disable-next-line: no-bitwise
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    // then to call it, plus stitch in '4' in the third group
    // tslint:disable-next-line: max-line-length
    return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
  }


}

